<template>
  <div>
    <CDropdownDivider v-if="showDivider" />
    <div class="p-2">
      <CRow>
        <CCol>
          <CBadge class="mb-1" :color="offer.offerType == 'FIRM' ? 'info' : 'secondary'"><div style="font-size: 120%;">Lot {{offer.getLot()}}</div></CBadge>
        </CCol>
        <CCol>
          <div class="nowrap float-right">
            <strong>{{ offer.quantityRemaining }}</strong>mt @ <strong>${{ offer.price }}</strong> /mt
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          <div class="pt-2">
            <strong class="mb-0">{{ offer.grainLabel }}</strong>
            <span v-if="offer.grade"> | {{ offer.gradeLabel }}</span>
          </div>
          <div class="pt-2 pb-2 d-flex">
            <div class="pr-1"><CLink><CIcon name="cil-location-pin"/></CLink></div>
            <div>{{ offer.located(true) }}</div>
          </div>
        </CCol>
        <CCol col=3>
          <div class="float-right text-right" xstyle="position: relative; top: 2px;">
            <div v-if="offer.offerType === 'INDICATIVE'"><CBadge color="secondary">INDICATIVE</CBadge></div>
            <div v-if="offer.offerType === 'FIRM'"><CBadge color="info">FIRM</CBadge></div>
            <div v-if="offer.isWithdrawn"><CBadge color="danger">WITHDRAWN</CBadge></div>
            <div v-if="offer.isComplete"><CBadge color="warning">TRADED</CBadge></div>
            <div v-if="!offer.isPublic"><CBadge color="danger">PRIVATE</CBadge></div>
            <div v-if="offer.isUpdated"><CBadge color="primary">UPDATED</CBadge></div>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm=12 md=6 class="pl-2 pb-0">
          <ul class="pl-4 mb-1">
            <li>Listed {{ offer.dateCreatedFormatted }}</li>
            <li>{{ offer.seasonLabel }}</li>
            <li>{{ offer.pricingMethodLabel }}</li>
            <li v-if="offer.pesticideFree">Declared free of pesticide</li>
            <li v-if="offer.bidPriceSpread" >Best bid: {{ offer.bidPriceSpread }}</li>
          </ul>
        </CCol>
      </CRow>
    </div>
  </div>
</template>

<script>
import Offer from '@/model/offer'

export default {
  name: 'OfferCardSmall',
  props: {
    offer: Offer,
    showDivider: {
      type: Boolean,
      default: true
    }
  }
}
</script>
